// swiper
class SwiperComponents extends HTMLElement {
  constructor() {
    super();
    this.initSwiper = this.getAttribute('data-swiper');
    this.swiperSlides = this.getAttribute('data-slides');
    this.swiperMobileSlides = this.getAttribute('data-mobile-slides');
    this.spaceBetween = this.getAttribute('data-spaceBetween');

    this.swiper = this.querySelector('[id^="Swiper-"]');
    this.sliderButtonPrev = this.querySelector('[id^="SwiperPrev-"]');
    this.sliderButtonNext = this.querySelector('[id^="SwiperNext-"]');

    this.spaceBetweenMobile = (this.spaceBetween.toString() === '0') ? 0 : Math.floor(this.spaceBetween / 2);

    if(this.initSwiper === 'false') return;
    this.swiperSlide();
  }

  swiperSlide() {
    var swiper = new Swiper(this.swiper, {
      slidesPerView: 1,
      spaceBetween: this.spaceBetweenMobile,
      navigation: {
        prevEl: this.sliderButtonPrev,
        nextEl: this.sliderButtonNext
      },
      breakpoints: {
        480: {
          slidesPerView: this.swiperMobileSlides,
          spaceBetween: this.spaceBetweenMobile,
        },
        990: {
          slidesPerView: this.swiperSlides,
          spaceBetween: this.spaceBetween,
        }
      }
    });
  }
}

customElements.define('swiper-component', SwiperComponents);
